import { Duration } from '@js-joda/core';

import {
   CurrentHealthcareProviderConfiguration,
   RequestsForAppointmentConfiguration,
} from '@dreryk/egabinet-patient-portal-frontend-api';
import { EmailAddress } from '@dreryk/email-address-common-api';

import { Choice } from '@dreryk/watermelon';

import { AppointmentRequestsSettingsFormBean } from './AppointmentRequestsSettingsForm.types';

export const DEFAULT_SLOT_BOOKING_LEAD_PERIOD_IN_HOURS = 24;

export const appointmentRequestsConfigurationToFormBean = (
   configuration: CurrentHealthcareProviderConfiguration | null,
   defaultAppointmentRequestsEmail: EmailAddress | null
): AppointmentRequestsSettingsFormBean => {
   const { requestsForAppointmentConfiguration, slotBookingLeadPeriod } = configuration ?? {};
   const slotBookingLeadPeriodInHours = slotBookingLeadPeriod?.toHours();
   return {
      allowAppointmentRequests: requestsForAppointmentConfiguration?.enabled ?? false,
      allowCustomAppointmentRequests: requestsForAppointmentConfiguration?.allowWithAvailableSlots ?? false,
      appointmentRequestsEmail:
         requestsForAppointmentConfiguration?.appointmentRequestsEmail ?? defaultAppointmentRequestsEmail,
      slotBookingLeadPeriodInHours: slotBookingLeadPeriodInHours ?? DEFAULT_SLOT_BOOKING_LEAD_PERIOD_IN_HOURS,
      blockShortAdvanceBooking: slotBookingLeadPeriodInHours !== undefined,
   };
};

export const formBeanToRequestsForAppointmentConfiguration = (
   bean: AppointmentRequestsSettingsFormBean
): RequestsForAppointmentConfiguration => {
   const enabled = bean.allowAppointmentRequests ?? false;
   const allowWithAvailableSlots = bean.allowCustomAppointmentRequests ?? false;
   return {
      enabled: enabled,
      allowWithAvailableSlots: allowWithAvailableSlots,
      appointmentRequestsEmail:
         enabled || allowWithAvailableSlots ? bean.appointmentRequestsEmail ?? undefined : undefined,
   };
};

export const formBeanToSlotBookingLeadPeriod = (
   bean: AppointmentRequestsSettingsFormBean
): Choice<Duration> | undefined => {
   if (!bean.blockShortAdvanceBooking || bean.slotBookingLeadPeriodInHours === null) {
      return undefined;
   }
   return Choice.of(Duration.ofHours(bean.slotBookingLeadPeriodInHours));
};
